// npm
import moment from 'moment'
import { get, split } from 'lodash'
// module
import store from '@/store'
// other
import { resolvePortLabels } from '@/utils/ports'
import { shortenizeFullName } from '@/utils/misc'
import {FlightOrderDisplay} from '@/models/flighOrderDisplay'

export function makeFlightOrderDisplay (flightOrder, useClientSearchString) {
  const depPortLabels = resolvePortLabels(flightOrder.depPortId)
  const arrPortLabels = resolvePortLabels(flightOrder.arrPortId)
  const from = get(depPortLabels, 'label', flightOrder.orderData.from)
  const to = get(arrPortLabels, 'label', flightOrder.orderData.to)

  // console.log('depPortLabels: %o, arrPortLabels: %o', depPortLabels, arrPortLabels)

  let flightOrderDisp = {
    'id': flightOrder.id,
    from,
    to,
    depPortId: flightOrder.depPortId,
    arrPortId: flightOrder.arrPortId,
    depPortLabels,
    arrPortLabels,
    'flightDateString': formatDate(flightOrder.flightDate, 'YYYY-MM-DD'),
    'flightDate': moment.utc(flightOrder.flightDate).toDate(),
    'initiator': getInitiatorName(flightOrder.initiatorUserId),
    'pnr': flightOrder.pnr,
    'source': flightOrder.source,
    /*
        'createUser': ?
        'createDate': formatDate(flightOrder.depDate, 'yyyy-mm-dd HH:mi:ss')
        'updateUser': ?
        'updateDate': formatDate(flightOrder.depDate, 'yyyy-mm-dd HH:mi:ss')
    */
    'searchString': flightOrder.searchString,
    'isCargo': flightOrder.cargo,
    //
    'orderData': flightOrder.orderData,
    'processData': flightOrder.processData,
    'organization': flightOrder.orderData.organization,
    'title': createFlightOrderTitle(flightOrder),
    //
    '_flightOrder' : flightOrder
  }
  if (flightOrder.orderData.linkedOrderIds) {
    flightOrderDisp.linkedOrderIds = split(flightOrder.orderData.linkedOrderIds, ';').map(i => i * 1)
  }
  if (!flightOrder.cargo) {
    flightOrderDisp.shortName = shortenizeFullName(flightOrder.orderData.fullName)
    flightOrderDisp.birthDateStr = formatDate(flightOrder.orderData.birthDate, 'YYYY-MM-DD')
  }

  let searchString = (flightOrder.searchString && useClientSearchString !== true) ? flightOrder.searchString : makeFlightOrderDispSearchString(flightOrderDisp)
  flightOrderDisp.searchString = searchString.toLowerCase()

  return FlightOrderDisplay.assign(flightOrderDisp)
}

function createFlightOrderTitle (flightOrder) {
  let title = ''
  if (flightOrder.cargo) {
    const { name, dimensions, packType, placeCount, weight } = flightOrder.orderData
    title = `${name} ${placeCount ? '(' + placeCount + ')' : ''} ${packType ? packType : ''}(${dimensions ? dimensions + ', ' : ''}${weight}kg)`
  } else {
    const { fullName, docNum } = flightOrder.orderData
    const shortName = shortenizeFullName(fullName)
    title = `${shortName}, ${docNum}`
  }
  return title
}

function formatDate (dateStr, format) {
  let m = moment(dateStr).utc(true)
  if (!m.isValid()) {
    return null
  }
  return format !== undefined ? m.format(format) : m.toISOString()
}

// TODO: implement it
function getInitiatorName (userId) {
  const initiators = get(store.getters.user, ['roleUsers', 'INITIATORS'], [])
  return initiators.find(user => user.id === userId) || userId
}

/**
 * returns array with indexed flight orders and search strings
 * FIXME: remove indexes or flight orders?
 * @param fligthOrders
 * @returns {*}
 */
export function makeFlightOrderDispSearchStrings (fligthOrderContainers, toLowerCase = true) {
  fligthOrderContainers.forEach((flightOrderContainer, index) => {
    let searchString = makeFlightOrderDispSearchString(flightOrderContainer.flightOrderDisp)
    if (toLowerCase) {
      searchString = searchString.toLowerCase()
    }
    flightOrderContainer.searchString = searchString
  })
}

export function makeFlightOrderDispSearchString (fligthOrderDisp) {
  let searchCommonStringKeys = ['source', 'flightDate', 'depPort', 'arrPort', 'initiator', 'pnr']
  let searchOrderDataStringKeys = (fligthOrderDisp.isCargo) ? ['contacts', 'dimensions', 'email', 'mvz', 'organization', 'packType', 'depDate', 'name']
    : ['fullName', 'organization', 'email', 'mvz', 'docNum', 'depDate']

  let searchStringCommon = searchCommonStringKeys.map(k => get(fligthOrderDisp, k)).join(' ')
  let searchString = searchOrderDataStringKeys.map(k => get(fligthOrderDisp.orderData, k)).join(' ')

  return searchStringCommon + ' | ' + searchString
}



// WEBPACK FOOTER //
// ./src/components/flight-orders/scrolled/flightOrderConverter.js